import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "app-loading-icon",
  templateUrl: "./loading-icon.component.html",
  styleUrls: ["./loading-icon.component.scss"]
})
export class LoadingIconComponent implements OnInit {

  /**
   * Show the "Loading" text
   */
  @Input()
  public showText ?= true;

  /**
   * Add additional context to what is loading
   */
  @Input()
  public text?: string;

  /**
   * The size of the loading icon
   */
  @Input()
  public size?: LoadingIconSize = LoadingIconSize.md;

  constructor() { }

  ngOnInit() { }

}

/**
 * Loading Icon Sizes
 */
export enum LoadingIconSize {
  xs = "xs",
  sm = "sm",
  md = "md",
  lg = "lg",
  xl = "xl"
}
